// extracted by mini-css-extract-plugin
export default {"form":"various-form_form__FHq2z","containerField":"various-form_containerField__3sWjT","name":"various-form_name__-eF23","delete":"various-form_delete__FzGdw"};